<template>
    <div class="modal-card contact-modal-step-two" v-if="project">
        <header class="modal-card-head">
            <p class="modal-card-title">Kontakt {{student.name | prettyName}}</p>

            <button @click="close" class="delete" :aria-label="$t('global.actions.close')" />
        </header>

        <section class="modal-card-body">
            <div class="columns">
                <div class="column">
                    <steps :step="2"/>

                    <div class="has-text-centered"  v-if="customer">
                        <template v-if="isLoggedIn">
                                <p>Du er logget ind som {{customer.name | prettyName}}, og er klar til at fortsætte.</p>
                                <br>
                                <p>Ikke dig? Tryk her for at logge ud.</p>
                                <br>
                                <button class="button" @click="signOut">{{$t('global.actions.logout')}}</button>
                        </template>

                        <p v-else>
                            Velkommen til Taskflex, {{customer.name | prettyName}}. <br>
                            Du kan sende beskeden nu. Vi har sendt dig en email med kodeord og link til at bekræfte din email. Derefter kan du logge ind.
                        </p>
                    </div>

                    <template v-else>
                        <div class="has-text-centered">
                            <p>Vi skal vide hvem du er så du kan få at vide når den studerende har svaret.</p>
                            <br>

                            <p>Du registerer dig herunder, vi behøver kun dit navn, telefonnummer og emailadresse. <br/> Alternativt kan du logge ind hvis du har en bruger i forvejen.</p>
                            <br>
                        </div>

                        <b-tabs v-model="tab" type="is-toggle" expanded>
                            <b-tab-item label="Registrer dig" icon="account-plus">
                                <quick-customer-registration @registered="setRegisteredCustomer" />
                            </b-tab-item>

                            <b-tab-item label="Log ind" icon="login-variant">
                                <quick-user-login @loggedIn="setLoggedInCustomerFromUser" :allowed-account-types="['customer']"/>
                            </b-tab-item>
                        </b-tabs>
                    </template>
                </div>
            </div>
        </section>

        <footer class="modal-card-foot">
            <b-field grouped position="is-right" style="width: 100%">
                <p class="control" v-if="hasErrors">
                    <span class="help is-danger is-pulled-right">Du mangler at logge ind eller registrere dig.</span>
                </p>

                <p class="control">
                    <button class="button is-default no-margin-bottom" @click="back">{{$t('global.actions.back')}}</button>

                    <button class="button is-primary no-margin-bottom"  @click="next" :disabled="hasErrors">
                        <span>{{$t('global.actions.next')}}</span>
                        <b-icon icon="chevron-right" />
                    </button>
                </p>
            </b-field>
        </footer>
    </div>
</template>

<style lang="scss" scoped>
    .buttons {
        .button {
            margin-bottom: 10px;
        }

        .help {
            margin-bottom: 10px;
            margin-top: 0;
            padding: calc(0.375em - 1px) 0.75em;
        }
    }
</style>

<script>
    import { mapGetters, mapMutations } from 'vuex';
    import {
        SET_PROJECT_CUSTOMER,
        SET_PROJECT_CUSTOMER_STATUS,
        SET_PROJECT_STEP,
        STEP_ONE,
        STEP_THREE,
        LOGGED_IN,
        NEW_REGISTRATION,
    } from '@/taskflex/students/store/contactForm/_types';
    import Steps from '@/taskflex/students/components/contact/Steps';
    import QuickUserLogin from '@/infrastructure/auth/components/QuickUserLogin';
    import QuickCustomerRegistration from '@/taskflex/customers/components/QuickCustomerRegistration';

    export default {
        data() {
            return {
                tab: 0,
            };
        },

        computed: {
            ...mapGetters('contactForm', [
                'project',
            ]),

            ...mapGetters('auth', [
                'isLoggedIn',
            ]),

            student() {
                const { student } = this.project;

                return student;
            },

            customer() {
                const { customer } = this.project;

                return customer;
            },

            customerStatus() {
                const { customerStatus } = this.project;

                return customerStatus;
            },

            hasErrors() {
                return !this.customer || !this.customerStatus;
            },
        },

        methods: {
            ...mapMutations('contactForm', {
                setCustomer: SET_PROJECT_CUSTOMER,
                setCustomerStatus: SET_PROJECT_CUSTOMER_STATUS,
                setStep: SET_PROJECT_STEP,
            }),

            signOut() {
                this.setCustomer(null);
                this.setCustomerStatus(null);

                this.$store.dispatch('auth/logout');
            },

            setLoggedInCustomerFromUser({ account }) {
                this.setCustomer(account);
                this.setCustomerStatus(LOGGED_IN);
            },

            setRegisteredCustomer(account) {
                this.setCustomer(account);
                this.setCustomerStatus(NEW_REGISTRATION);
            },

            back() {
                this.setStep(STEP_ONE);
            },

            next() {
                if (this.hasErrors) {
                    return;
                }

                this.setStep(STEP_THREE);
            },

            close() {
                this.$emit('hide');
            },
        },

        components: {
            Steps,
            QuickUserLogin,
            QuickCustomerRegistration,
        },
    };
</script>



// WEBPACK FOOTER //
// src/taskflex/students/components/contact/StepTwo.vue